module.exports = __webpack_public_path__ + "2067a95ae9a6f326d15f7faaaf7c2cf2.svg";